const DEFAULT_POINTS = [
  { title: "数据来源广、精准度高", body: "多报表与多维度指标自动对齐，减少人工汇总误差。" },
  { title: "流程可配置", body: "按团队角色拆分权限与审批路径，适配不同规模组织。" },
  { title: "模块可扩展", body: "与采购、仓储、财务等模块联动，形成一体化视图。" },
  { title: "持续迭代", body: "支持平滑升级与订阅组合，随业务发展扩展能力。" }
];

export function normalizeBullet(s) {
  if (s != null && typeof s === "object" && !Array.isArray(s)) {
    const title = s.title != null ? String(s.title).trim() : "";
    const body = s.body != null ? String(s.body).trim() : "";
    return { title, body };
  }
  const t = typeof s === "string" ? s : String(s);
  const m = t.match(/^([^：:]+)[：:]\s*(.+)$/);
  if (m) return { title: m[1].trim(), body: m[2].trim() };
  return { title: "", body: t.trim() };
}

function valueLineFromPoints(item) {
  if (!Array.isArray(item.points)) return "";
  for (const p of item.points) {
    const n = normalizeBullet(p);
    if (String(n.title || "").trim() === "价值" && n.body) {
      return String(n.body).trim();
    }
  }
  return "";
}

export function subtitleFor(item) {
  let base;
  if (item.subtitle) {
    base = String(item.subtitle).trim();
  } else {
    const intro = (item.intro || "").trim();
    if (!intro) base = "整合关键业务数据，让经营结果一目了然。";
    else {
      const first = intro.split(/\r?\n/)[0];
      base = first.length > 96 ? `${first.slice(0, 96)}…` : first;
    }
  }
  const explicit = (item.valueNote || "").trim();
  const fromPoints = valueLineFromPoints(item);
  const extra = explicit || fromPoints;
  if (!extra) return base;
  if (base.includes(extra)) return base;
  return `${base} ${extra}`.trim();
}

export function pointsFor(item) {
  if (Array.isArray(item.points) && item.points.length) {
    return item.points
      .map((s) => normalizeBullet(s))
      .filter((pt) => String(pt.title || "").trim() !== "价值");
  }
  if (Array.isArray(item.bullets) && item.bullets.length) {
    return item.bullets
      .map((s) => normalizeBullet(s))
      .filter((pt) => String(pt.title || "").trim() !== "价值");
  }
  const intro = (item.intro || "").trim();
  const lines = intro
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean);
  if (lines.length > 1) {
    return lines.map((s) => normalizeBullet(s));
  }
  if (lines.length === 1) {
    const parts = lines[0]
      .split(/[。；;]\s*/)
      .map((s) => s.trim())
      .filter((s) => s.length > 6);
    if (parts.length > 1) return parts.map((s) => normalizeBullet(s));
  }
  return DEFAULT_POINTS;
}
